import {useContext} from 'react'
import {t} from '../../i18n'
import {Heading} from '../Heading'
import {Red} from '../Red'
import {Container} from './components/Container'
import {CustomLanding36252Context} from '../../reducer'
import {BodyText} from '../BodyText'
import {Items} from './components/Items'
import {Item} from './components/Item'
import {ReactComponent as Shield} from '../../assets/shield.svg'
import {ItemHeader} from './components/ItemHeader'
import {ReactComponent as Comp} from '../../assets/comp.svg'
import {ReactComponent as Arrows} from '../../assets/arrows.svg'
import {ReactComponent as Earth} from '../../assets/earth.svg'
import {Button} from '@material-ui/core'
import {CustomLanding36252ActionType} from '../../types'

export const WhyUs = () => {
  const [state, dispatch] = useContext(CustomLanding36252Context)

  const handleDismiss = () => {
    dispatch?.({
      type: CustomLanding36252ActionType.Dismiss,
    })
  }

  return (
    <Container>
      <Heading>
        {t[state.language].whyChoose}
        <Red> {t[state.language].tauroMarkets}</Red>
      </Heading>
      <BodyText>{t[state.language].registerToday}</BodyText>
      <Items>
        <Item>
          <Shield />
          <ItemHeader>{t[state.language].regulatedBy}</ItemHeader>
          <BodyText style={{textAlign: 'left'}}>{t[state.language].fullyLicensed}</BodyText>
        </Item>
        <Item>
          <Comp />
          <ItemHeader>{t[state.language].mt5}</ItemHeader>
          <BodyText style={{textAlign: 'left'}}>{t[state.language].tradeSmarter}</BodyText>
        </Item>
        <Item>
          <Arrows />
          <ItemHeader>{t[state.language].spreads}</ItemHeader>
          <BodyText style={{textAlign: 'left'}}>{t[state.language].enjoyTight}</BodyText>
        </Item>
        <Item>
          <Earth />
          <ItemHeader>{t[state.language].multilingualSupport}</ItemHeader>
          <BodyText style={{textAlign: 'left'}}>{t[state.language].ourGlobalSupportTeam}</BodyText>
        </Item>
      </Items>
      <Button
        variant="contained"
        color="primary"
        style={{fontSize: '16px'}}
        onClick={handleDismiss}
      >
        {t[state.language].registerAndClaim}
      </Button>
    </Container>
  )
}
